import { useQuery } from "@tanstack/react-query";
import { type MonthlyBudget, budgetApi } from "../lib/budget";

export function useMonthlyBudget(month?: string) {
  return useQuery<MonthlyBudget>({
    queryKey: ["budget", "monthly", month ?? "current"],
    queryFn: () => budgetApi.getMonthly(month),
  });
}
